// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"235ffb61","453":"2ea46ae1","732":"19ac56bf"}[chunkId] + ".chunk.js";
};